// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__hQVVu","lds-dual-ring":"Loading_lds-dual-ring__UdWLX"};